<template>
	<div v-if="!loading">
		<el-pagination
			class="pull-right"
			background
			@current-change="changePage"
			@size-change="changeSize"
			:page-sizes="pageSizes"
			:current-page="model.page"
			:page-size="model.limit"
			:layout="layout"
			:total="model.totalDocs" />
		<el-table
			
			:data="model.docs">
			<el-table-column
				width="80"
				label="">
				<template slot-scope="scope">
					<router-link :to="url(scope)" class="btn btn-info btn-lg px-3 py-2">
						<i class="tim-icons icon-pencil"></i>
					</router-link>
				</template>
			</el-table-column>
			<slot name="columns"></slot>
			<el-table-column
				v-if="deleteColumn"
				width="80"
				label="X">
				<template slot-scope="scope">
					<div class="">
						<base-button type="link" class="text-danger" @click="deleteRequest(scope)">
							<i class="tim-icons icon-trash-simple"></i>
						</base-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			class="pull-right"
			background
			@size-change="changeSize"
			:current-page="model.page"
			@current-change="changePage"
			:page-size="model.limit"
			layout="sizes, prev, pager, next"
			:total="model.totalDocs" />
	</div>
	<div v-else>
		loading?  {{loading}}
		{{model}}
	</div>
</template>
<script>
import { Table, TableColumn, Pagination } from 'element-ui'
import { mapState, mapActions } from 'vuex'

export default{
	name: 'im-table',
	props: {
		pageSizes: {
			type: Array,
			default: () => [100]
		},
		deleteColumn: {
			type: Boolean,
			default: true,
		},
		layout: {
			type: String,
			default: 'sizes, prev, pager, next'
		},
		model: Object,
		loading: Boolean,
		url: Function,
	},
	components: {
		[TableColumn.name]: TableColumn,
		[Table.name]: Table,
		[Pagination.name]: Pagination
	},
	methods: {
		changePage(page) {
			this.$emit('getAll',{
				page
			});
		},
		changeSize(limit){
			this.$emit('getAll',{
				limit
			});
		},
		deleteRequest(scope) {
			this.$emit('delete',scope)
		},
		primaryEmailField(emails,field) {
			var emails = emails.filter(email => email.primary);
			return emails.length ? emails[0][field] : '';
		}
	},
}
</script>